import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading, ToastController, Platform } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import * as firebase from 'firebase/app';
import moment from 'moment';

import { DateTimeAdapter } from 'ng-pick-datetime';

interface myInterface2 {
  id: string;
  creationDate: Date;
  description: string;
  files: any[];
  idAlumno: string;
  idCoach: string;
  name: string;
  sessionDate: Date;
  tasks: string[];
}

interface myInterface3 {
  id: string;
  creationDate: Date;
  description: string;
  files: any[];
  idAlumno: string;
  idCoach: string;
  title: string;
  sessionDate: Date;
  tasks: string[];
}

@IonicPage()
@Component({
  selector: 'page-task-update',
  templateUrl: 'task-update.html',
})
export class TaskUpdatePage {

  data: any;
  myForm: FormGroup;
  inputFile: any[] = [""];
  files: any[] = [];
  arrayFiles: any[] = [];
  loading: Loading;
  idItem: string = '';

  sessionDoc: AngularFirestoreDocument<myInterface2>;
  session: myInterface2;

  sessionsCollection: AngularFirestoreCollection<myInterface3>;
  sessions: myInterface3[];


  public min = moment().format();
  public min2 = new Date();
  public isMobile: boolean;

  constructor(platform: Platform, dateTimeAdapter: DateTimeAdapter<any>, public asf: AngularFirestore, public navCtrl: NavController, public navParams: NavParams, public formBuilder: FormBuilder, public toastCtrl: ToastController, public loadingCtrl: LoadingController) {
    dateTimeAdapter.setLocale('es-ES'); // change locale to spanish
    this.data = this.navParams.get("item");
    this.idItem = this.data.id;
    this.myForm = this.formBuilder.group({
      description: [this.data && this.data.description ? this.data.description : '', Validators.required],
      dueDate: [this.data && this.data.dueDate ? new Date(this.data.dueDate).toISOString() : ''],
      idSesion: [this.data && this.data.idSesion ? this.data.idSesion : '', Validators.required],
      title: [this.data && this.data.title ? this.data.title : '', Validators.required]
    });


    this.sessionsCollection = this.asf.collection("Sessions", ref => ref.where("idAlumno", "==", this.data.idAlumno).where("idCoach", "==", this.data.idCoach).orderBy("sessionDate", "desc"));
    this.sessionsCollection.snapshotChanges().subscribe((data) => {
      this.sessions = data.map((item) => {
        const data = item.payload.doc.data() as myInterface3;
        const id = item.payload.doc.id;
        return { id, ...data }
      });
    });

    this.sessionDoc = this.asf.doc("Tasks/" + this.data.id);
    this.sessionDoc.snapshotChanges().subscribe(item => {
      const data = item.payload.data() as myInterface2;
      const id = item.payload.id;
      this.session = { id, ...data };
    });
    platform.ready().then(() => {
      if (platform.is('mobile')) {
        this.isMobile = true;
      } else {
        ////console.log('browser');
        this.isMobile = false;
      }
    });
  }

  deleteFromArray(index: number) {
    //agregar funcion para eliminar los archivos de estorage
    this.presentLoadingCustom();
    this.session.files.splice(index, 1);
    this.asf.doc('Tasks/' + this.data.id).update({ "files": this.session.files }).then(res => {
      this.loading.dismiss();
      this.presentToast("Archivo agregado correctamente");
    }).catch(error => {
      this.loading.dismiss();
      ////console.log(error);
      this.presentToast(error);
    });
  }

  addFile(event: any) {
    if (event && event.target && event.target.value) {
      this.presentLoadingCustom();
      this.uploadFileSStorage({ "file": event.target.files[0] }).then((data) => {
        this.session.files.push(data);
        this.asf.doc('Tasks/' + this.data.id).update({ "files": this.session.files }).then(res => {
          this.loading.dismiss();
          this.presentToast("Archivo agregado correctamente");
        }).catch(error => {
          this.loading.dismiss();
          ////console.log(error);
          this.presentToast(error);
        });
      }).catch((error) => {
        this.loading.dismiss();
        ////console.log(error);
        this.presentToast(error);
      });
    }
  }

  async uploadFileSStorage(file: any): Promise<any[]> {
    let filesRet;
    var storageRef = firebase.storage().ref();
    var fileRef = storageRef.child('files/' + new Date().getTime() + file.file.name);
    await fileRef.put(file.file).then((res) => {
      filesRet = { "downloadURL": res.downloadURL, "fullPath": res.metadata.fullPath, "name": file.file.name }
    });
    return filesRet;
  }

  ionViewDidLoad() { }

  onSubmit() {
    this.presentLoadingCustom();
    let date;
    if (this.isMobile) {
      let dif = (moment(this.myForm.value.sessionDate).utcOffset() / 60) * -1;
      date = moment(this.myForm.value.sessionDate).add(dif, "hours");
    } else {
      date = this.myForm.value.sessionDate;
    }
    let update =
    {
      description: this.myForm.value.description,
      dueDate: this.myForm.value.dueDate ? new Date(this.myForm.value.dueDate) : '',
      idSesion: this.myForm.value.idSesion,
      title: this.myForm.value.title
    }
    this.asf.doc('Tasks/' + this.data.id).update(update).then(res => {
      this.loading.dismiss();
      this.presentToast("Tarea editado correctamente");
      this.navCtrl.pop();
    }).catch(error => {
      this.loading.dismiss();
      ////console.log(error);
      this.presentToast(error);
    });
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  cancel() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/task-update/task-update.ts